"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.m4 = exports.m3 = exports.m2 = exports.m1 = exports.b4 = exports.b3 = exports.b2 = exports.b1 = void 0;
// Breakpoints.
exports.b1 = 520;
exports.b2 = 960;
exports.b3 = 1300;
exports.b4 = 1800;
exports.m1 = `@media (max-width:${exports.b1}px)`;
exports.m2 = `@media (max-width:${exports.b2}px)`;
exports.m3 = `@media (max-width:${exports.b3}px)`;
exports.m4 = `@media (max-width:${exports.b4}px)`;
